export const comments_4791868 = {"data":{"data":[],"links":{}}}